import { CLIENT_ID } from './client.model';
export type ROLE_ID = number;
export class Role {
  id: ROLE_ID;
  client_id: CLIENT_ID;
  name: string;
  permissions: string[];
  isDefault: boolean;
  isClientAdmin: boolean;
  /** A user manages only users and roles strictly below their own level (YB-2166). */
  hierarchy_level?: number;
  /** The system role this copies; null for a client's custom role. */
  template_name?: string | null;
}

export class GetRoleInput {
  id: ROLE_ID = NaN;
  isDefault?: boolean = false;
  isClientAdmin?: boolean = false;
  client_id: CLIENT_ID = NaN;
  name?: string = '';
  permissions?: string[] = [];
  hierarchy_level?: number = 0;
  template_name?: string = '';
}
